<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_sx.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_sx.png'
import list_img1 from '../../images/download/down-sx1.png'
import list_img2 from '../../images/download/down-sx2.png'
import list_img3 from '../../images/download/down-sx3.png'
import cut_img1 from '../../images/download/cut_sx1.png'
import cut_img2 from '../../images/download/cut_sx2.png'
import cut_img3 from '../../images/download/cut_sx3.png'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'闲来陕西麻将',
                size:'95.09',
                load_count:'2016',
                desp:'陕西麻将是一个四个人才能玩的游戏。陕西麻将玩法简单、爽快，计算方便，而受到广大玩家欢迎。下炮子等特色玩法让游戏更加激烈刺激。 麻将文化源远流长，本身是由明末盛行的马吊牌、纸牌发展演变而来。麻将运动不仅具有独特的游戏特点，而且还是一种集益智性、趣味性、和博弈性的运动。',
                ios_url:'http://app6.auwvnd.cn/?downloadfrom=shanxi',
                android_url:'http://app6.auwvnd.cn/?downloadfrom=shanxi',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:cut_img1,
                cut_img2:cut_img2,
                cut_img3:cut_img3
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
